import { RouteFactory } from "@app/routePaths";
import { BT_NEWSLETTERS } from "@components/Newsletter/types/Newsletter";

export const NEWSLETTER_PAGE_LINK = RouteFactory.newsletterSignup;
export const DAILY_NEWSLETTERS = BT_NEWSLETTERS.slice(0, 2);
export const WEEKLY_NEWSLETTERS = BT_NEWSLETTERS.slice(2);
export const newsletterLinks = [
  { linkText: "Daily Newsletters" },
  { linkText: "Weekly Newsletters" },
];
